<template>
  <div
    class="modal fade"
    id="updateOrder"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-labelledby="updateOrderLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="updateOrderLabel">
            ปรับสถานะใบส่งของ 
            <span class="text-primary">{{ order.do_ref }}</span>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="!appearForm" class="well well-sm text-center">
            <i class="fa fa-cog fa-spin fa-fw"></i>
            {{ message }}
          </div>
          <form v-else id="dataForm" @submit.prevent="saveData">
            <label>สถานะใบส่งของ</label>
            <div v-for="order_status in order_statuses" :key="`status${order_status.id}`">
              <input type="radio" v-model="selectedStatus" name="profileImg" :value="order_status.id"> {{ order_status.name }}
            </div>
            <div class="form-group my-3" v-if="selectedStatus !== null && selectedStatus == 3">
              <label>วันที่รับเงิน*</label>
              <v-date-picker
                :input-props="{ placeholder: 'คลิกเพื่อเปิดปฏิทิน' }"
                locale="th"
                title-position="left"
                :marks="formats"
                :popover="{ placement: 'top', visibility: 'click' }"
                v-model="order.received_date"
              ></v-date-picker>
            </div>
          </form>
        </div>
        <div class="modal-footer d-flex" v-if="appearForm">
          <button
            class="btn btn-primary ml-auto"
            form="dataForm"
            :disabled="submitted || !valid"
          >บันทึกข้อมูล</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSingleSelect from "vue-single-select";
import VCalendar from "v-calendar";
export default {
  components: {
    VCalendar,
    VueSingleSelect
  },
  data() {
    return {
      appearForm: false,
      message: "กำลังดาวน์โหลดข้อมูล กรุณารอสักครู่",
      submitted: false,
      selectedStatus: null,
      order_statuses: [],
      formats: {
        title: "MMMM YYYY",
        weekdays: "W",
        navMonths: "MMM",
        input: ["DD/MM/YYYY"],
        dayPopover: "L",
        data: ["L", "YYYY-MM-DD", "YYYY/MM/DD"]
      },
      order: {
        id: null,
        received_date: null,
      }
    };
  },
  created() {
    axios
      .all([axios.get("/order_statuses")])
      .then(
        axios.spread((orderStatusesRes) => {
          this.order_statuses = _.filter(orderStatusesRes.data, function(orderStatus) { 
            return orderStatus.id != 1; 
          });
        })
      )
      .catch(error => {
        alert("เกิดข้อผิดพลาด");
      });
  },
  mounted() {
    $("#updateOrder").on("show.bs.modal", event => {
      this.appearForm = false;
      var button = $(event.relatedTarget);
      var id = button.data("id");

      if (id === undefined) {
        this.appearForm = true;
        return;
      }

      axios
        .get("/orders/" + id)
        .then(response => {
          this.order = response.data;
          this.appearForm = true;

          if (this.order.received_date != null)
            this.order.received_date = new Date(this.order.received_date);

          // สถานะใบสั่งซื้อ
          this.selectedStatus = this.order.order_status_id;
        })
        .catch(error => console.log(error));
    });

    $("#updateOrder").on("hidden.bs.modal", event => {
      this.resetForm();
    });
  },
  methods: {
    isEmpty: str => !str || 0 === str.length,
    saveData: function() {
      this.disableForm();
      
      let toSubmitData = {
        order_status_id: this.order.order_status_id,
      };
      
      if (this.order.order_status_id == 3)
        toSubmitData.received_date = moment(this.order.received_date).format('YYYY-MM-DD');
      
      toSubmitData._method = "put";

      //ส่งข้อมูล
      axios.post("/orders/update_status/" + this.order.id, toSubmitData)
        .then(response => {
          $("#updateOrder").modal("hide"); //hide model
          this.$emit("update-success");
        })
        .catch(error => {
          $("#updateOrder").modal("hide"); //hide model
          this.$emit("update-fail");
        });
    },
    disableForm() {
      this.message = "กำลังดำเนินการ";
      this.submitted = true;
      this.appearForm = false;
    },
    resetForm() {
      this.order = {
        id: null,
        received_date: null,
      };
      this.submitted = false;
      this.appearForm = true;
      this.message = "กำลังดาวน์โหลดข้อมูล กรุณารอสักครู่";
    },
  },
  computed: {
    valid: function() {
      return this.order.order_status_id == 3 ? (!this.isEmpty(this.order.order_status_id) &&
             !this.isEmpty(this.order.received_date)) : !this.isEmpty(this.order.order_status_id);
    },
  },
  watch: {
    selectedStatus: function (value) {
      this.order.order_status_id = value ? value : null;
    },
  }
};
</script>
